export default {
  MuiFormControlLabel: {
    root: {
      '& .MuiRadio-root': { marginRight: 4, padding: 8 },
      '&.dense': { marginTop: -4, marginBottom: -4 },
      '&.small': {
        marginTop: 4,
        marginBottom: 4,
        '& .MuiRadio-root': {
          marginLeft: 4,
          marginRight: 4,
          '& .MuiIconButton-label > svg': { height: 16, width: 16 },
          '& .MuiTouchRipple-child': {
            borderRadius: 8,
          },
        },
        '& .MuiFormControlLabel-label': { fontSize: 14 },
        '&.dense': { marginTop: 0, marginBottom: 0 },
      },
    },
    label: { '&.Mui-disabled': { color: 'white', opacity: 0.4 } },
  },
};
